import { render, staticRenderFns } from "./RelatedCategoryMedia.vue?vue&type=template&id=1b4b53b8"
import script from "./RelatedCategoryMedia.vue?vue&type=script&lang=js"
export * from "./RelatedCategoryMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports